import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ProgramTargetGraphScreen';
import ProgramTargetGraph from './ProgramTargetGraphScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from '../../../../../../types/grid';
import { getProgramBookAnswers, getProgramBookEntity, getProgramBooks } from 'src/store/actions/program-book-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        programBooks: state.programBooks,
        programBook: state.programBooks.current,
        programBookAnswers: state.programBookAnswers,
        inProgressAnswers: state.programBookAnswers.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getProgramBooks: (params: QueryParams) => dispatch(getProgramBooks(params)),
        getProgramBookEntity: (id: string, isHidden: string) => dispatch(getProgramBookEntity(id, isHidden)),
        getProgramBookAnswers: (params: QueryParams) => dispatch(getProgramBookAnswers(params)),
    };
}

const ProgramTargetGraphScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProgramTargetGraph);

export default ProgramTargetGraphScreen;
